import { RequestStatus } from "@/domains/evidence-requests/constants";
import { EnumFunctions } from "@/shared/utils/constants";
import { BasePaginationQueryParams } from "@/redux/types";
import { BaseUserResponse } from "@/redux/users/types";

type RequestStatusValue = (typeof RequestStatus)[keyof Omit<
  typeof RequestStatus,
  keyof typeof EnumFunctions
>]["value"];

export interface DataBlockRequestFiltersState
  extends BasePaginationQueryParams {
  search?: string;
  user?: number;
  dataTemplates?: number[];
  status?: RequestStatusValue[];
  excludeUser?: number;
}

export type DataBlockRequestFiltersProps = {
  setFilters: (value: DataBlockRequestFiltersState) => void;
  defaultFilters?: Partial<DataBlockRequestFiltersState>;
  filterNames: string[];
};

export enum RecipientType {
  User = "USER",
  UserInvite = "USER_INVITE",
}

export interface DataBlockRequestRecipient {
  email: string;
  type: RecipientType;
}

export interface UserRecipient
  extends Omit<BaseUserResponse, "email">,
    DataBlockRequestRecipient {
  type: RecipientType.User;
}

export interface EmailRecipient extends DataBlockRequestRecipient {
  type: RecipientType.UserInvite;
}

export type Recipient = UserRecipient | EmailRecipient;

export enum UserInviteStatus {
  USER_INVITE = "USER_INVITE",
  USER = "USER",
}

export interface DataBlockRequestEditModalsState {
  open: boolean;
  request?: number;
}
